import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the authorization request's read, keyed on the URL's OAuth parameters; the page above
// reads it with `useMatch({ from })`. No component: nothing painted on a re-key.
export const Route = createFileRoute('/_public/oauth/authorize/_request')({
  loaderDeps: ({ search }) => ({
    clientId: search.client_id,
    redirectUri: search.redirect_uri,
    codeChallenge: search.code_challenge,
    codeChallengeMethod: search.code_challenge_method,
    state: search.state,
    resource: search.resource,
  }),
  context: ({ deps }) => {
    const authorizationRequest = {
      clientId: deps.clientId,
      redirectUri: deps.redirectUri,
      codeChallenge: deps.codeChallenge,
      codeChallengeMethod: deps.codeChallengeMethod,
      ...(deps.state === undefined ? {} : { state: deps.state }),
      ...(deps.resource === undefined ? {} : { resource: deps.resource }),
    }
    return {
      authorizationRequest,
      authorizationQueryOptions: trpc.mcp.describeAuthorization.queryOptions(authorizationRequest),
    }
  },
  loader: ({ context }) => {
    // Signed out, the page sends the visitor to log in first: nothing to read yet.
    if (!context.queryClient.getQueryData(context.sessionUserQueryOptions.queryKey)) return
    context.queryClient.query(context.authorizationQueryOptions).catch(noop)
  },
})
